export default class PreferredContactMethodIds {
    public static readonly PHONE = 1;
    public static readonly CELLPHONE = 2;
    public static readonly EMAIL = 3;
}